import type { Text } from 'pixi.js';
import { ModalCard } from './ModalCard';
import { COLORS, TYPE } from '../app/theme';
import { Button, makeText } from './widgets';
import { Spinner } from './Spinner';

/**
 * In-game "connection lost" overlay shown over the live table (Blackjack/Ready) while the
 * ReconnectController retries. Deliberately NOT tap-dismissible (no onDismiss) — the ModalCard scrim
 * blocks input to the frozen table beneath. The controller pushes status/countdown via setStatus() and
 * removes the modal on success/fallback. The single button lets the player bail to the login screen.
 */
export class ReconnectModal extends ModalCard {
  private readonly statusText: Text;

  constructor(onBack: () => void) {
    super({ width: 560, height: 420, title: 'ارتباط با سرور قطع شد' });

    const spinner = new Spinner();
    spinner.position.set(this.cardWidth / 2, this.contentTop + 64);
    this.content.addChild(spinner);

    this.statusText = makeText('در حال اتصال مجدد…', { size: TYPE.body, align: 'center', fill: COLORS.text });
    this.statusText.anchor.set(0.5, 0);
    this.statusText.style.wordWrap = true;
    this.statusText.style.wordWrapWidth = this.cardWidth - 80;
    this.statusText.position.set(this.cardWidth / 2, this.contentTop + 130);
    this.content.addChild(this.statusText);

    const btnW = this.cardWidth - 160;
    const back = new Button('بازگشت به ورود', onBack, {
      width: btnW,
      height: 60,
      fill: COLORS.panel,
      textColor: COLORS.text,
    });
    back.position.set((this.cardWidth - btnW) / 2, this.cardHeight - 84);
    this.content.addChild(back);
  }

  setStatus(text: string): void {
    this.statusText.text = text;
  }
}
